import { Vue, Component } from "vue-property-decorator";
import MakeComplaintDialog from "../../components/MakeComplaintDialog.vue";

@Component({
  components: {
    MakeComplaintDialog,
  },
})
export default class HelpCenter extends Vue {
  contacts = [
    {
      text: "support@jackocoins.com",
      link: "mailto:support@jackocoins.com",
      icon: "mdi-email",
    },
    {
      text: "jackocoins247@gmail.com",
      link: "mailto:jackocoins247@gmail.com",
      icon: "mdi-email",
    },
    {
      text: "+2349137393413",
      link: "https://wa.me/+2349137393413",
      icon: "mdi-whatsapp",
    },
    {
      text: "@RealJackocoins1",
      link: "https://x.com/RealJackocoins1",
      icon: "mdi-twitter",
    },
    {
      text: "Jackocoins",
      link: "https://www.facebook.com/jackocoins",
      icon: "mdi-facebook",
    },
  ];

  widgetLoading = false;

  showDialog: boolean = false;

  toggleDialogue() {
    this.showDialog = !this.showDialog;
  }

  closeDialog() {
    this.showDialog = false;
  }

  triggerHelpCenter() {
    if (!(window as any).Tawk_API) {
      this.widgetLoading = true;
      let s1 = document.createElement("script"),
        s0: any = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = "https://embed.tawk.to/63cf84d5c2f1ac1e202f46f7/1gnh9toqg";
      s1.charset = "UTF-8";
      s1.setAttribute("crossorigin", "*");
      s0.parentNode.insertBefore(s1, s0);
      setTimeout(() => {
        (window as any).Tawk_API.maximize();
        this.widgetLoading = false;
        (window as any).Tawk_API.onChatMinimize = function () {
          (window as any).Tawk_API.hideWidget();
        };
      }, 4000);
    } else {
      (window as any).Tawk_API.maximize();
      this.widgetLoading = false;
      (window as any).Tawk_API.onChatMinimize = function () {
        (window as any).Tawk_API.hideWidget();
      };
    }
  }

  beforeDestroy() {
    (window as any).Tawk_API.minimize();
  }
}
